import type { BranchListResponse } from './api';

export interface BranchOption {
  label: string;
  value: number;
}

export const normalizeBranchList = (list: BranchListResponse): BranchOption[] => {
  if (!list) {
    return [];
  }

  return list.map((row) => ({
    label: row.branchDesc,
    value: row.branchKey,
  }));
};
